import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Badge } from "@components/Badge/Badge";
import { DummyRadio } from "@components/inputs/Radio/DummyRadio";
import { type IAddBillVariantMethodButtonProps } from "../AddBillVariantSelectorModalTypes";

export const AddBillVariantMethodButtonEE: React.FC<
  IAddBillVariantMethodButtonProps
> = (props) => {
  const { badgeIcon, badgeColor, variant, selectedMethod, onClick, className } =
    props;

  const { t } = useTranslation();

  return (
    <button
      className={twMerge(
        "flex items-center gap-4 rounded-2xl border border-grey-light p-6 text-left",
        className,
      )}
      onClick={onClick}
      style={{ top: "0px" }}
    >
      <Badge
        icon={badgeIcon}
        variant="rounded"
        size="large"
        color={badgeColor}
      />
      <div className="flex flex-col gap-1">
        <span className="text-sm font-semibold">
          {t(`addBillVariantSelectorModal.methods.${variant}.title`)}
        </span>
        <span className="text-sm text-grey-dark">
          {t(`addBillVariantSelectorModal.methods.${variant}.description`)}
        </span>
      </div>
      <div className="flex flex-grow justify-end">
        <DummyRadio checked={variant === selectedMethod} />
      </div>
    </button>
  );
};
